import React from "react";
import "../styling/Terms.css";

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <p>
        By accessing or using VOETA services, you agree to be bound by the following terms and conditions. These terms apply to all users across our service areas, including Travel, Security, Cleaning, Real Estate, and Construction.
      </p>

      <h2>General Terms</h2>
      <ul>
        <li>All services must be scheduled in advance and are subject to availability and confirmation.</li>
        <li>VOETA reserves the right to modify, reschedule, or discontinue services at any time without prior notice.</li>
        <li>Clients are responsible for providing accurate and complete information when requesting or using our services.</li>
        <li>Fees, payment terms, and cancellation policies may vary by service type and region. These will be disclosed in service-specific agreements.</li>
      </ul>

      <h2>Travel Agency</h2>
      <ul>
        <li>All bookings are dependent on third-party provider availability (e.g., airlines, hotels, embassies).</li>
        <li>VOETA facilitates travel documentation, visa assistance, and bookings, but does not control external delays or policy changes.</li>
        <li>Clients must notify VOETA of cancellations or changes at least 48 hours prior to departure to avoid fees.</li>
        <li>It is the client's responsibility to ensure they meet visa and travel requirements for their destination.</li>
      </ul>

      <h2>Security Agency</h2>
      <ul>
        <li>Security service scope, location access, and protocols must be confirmed in writing before deployment.</li>
        <li>Our security personnel are professionally trained and licensed, but VOETA does not guarantee prevention of all security risks.</li>
        <li>Clients must report any incidents involving security personnel within 12 hours for investigation and resolution.</li>
        <li>VOETA reserves the right to replace assigned personnel based on operational needs.</li>
      </ul>

      <h2>Cleaning Agency</h2>
      <ul>
        <li>Scope of cleaning tasks, locations, and schedules must be outlined in a signed agreement.</li>
        <li>Clients are advised to store or secure valuables prior to any cleaning session. VOETA is not liable for misplaced items.</li>
        <li>Any damage or service issues must be reported within 24 hours of service completion for assessment.</li>
        <li>VOETA uses safe, certified cleaning materials; clients must disclose any surface/material sensitivities in advance.</li>
      </ul>

      <h2>Real Estate Agency</h2>
      <ul>
        <li>Property listings are subject to change based on owner availability and market activity.</li>
        <li>VOETA acts as an intermediary and is not liable for disputes between property owners and tenants or buyers.</li>
        <li>Clients must provide valid identification and documentation before any transaction or agreement.</li>
        <li>Service fees, legal responsibilities, and agreement terms will be disclosed before signing.</li>
      </ul>

      <h2>Construction Agency</h2>
      <ul>
        <li>All construction projects require signed contracts outlining project scope, timelines, materials, and payment terms.</li>
        <li>VOETA ensures compliance with safety regulations, but clients must ensure site access and permits are in place.</li>
        <li>Changes to approved designs or materials may result in timeline or cost adjustments.</li>
        <li>Project delays caused by weather, material shortages, or third parties are not the responsibility of VOETA.</li>
        <li>Clients must inspect completed work within 7 days and report any issues in writing.</li>
      </ul>

      <h2>Limitation of Liability</h2>
      <p>
        VOETA shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.
        Where applicable, VOETA’s total liability is limited to the amount paid by the client for the specific service in question.
      </p>
    </div>
  );
};

export default Terms;
